// @ts-strict-ignore
import React, { FC } from 'react'
import { useLiveQuery } from 'dexie-react-hooks'
import classnames from 'classnames'
import { ScreenSection } from 'mytours-read-common'
import { Question } from 'mytours-read-api-typescript'
import db from 'mobile_web/modules/db'
import { IonText, IonGrid, IonRow, IonCol } from '@ionic/react'
import { getDirMode } from '../../../platform'
import SectionHeader from './SectionHeader'
import '../styles/sectionQuizQuestion.less'
import QuizAnswersContentComponent from 'mobile_web/modules/quiz/components/QuizAnswersContent'

interface SectionQuizQuestionProps {
	section: ScreenSection
	language: string
}

const QuestionTypes = Question.QuestionTypeEnum

const SectionQuizQuestion: FC<SectionQuizQuestionProps> = ({ section, language }) => {
	if (!section.quiz_id) {
		return <div />
	}

	const question = useLiveQuery(() => db.quizQuestions.get({ id: section.question_id, quiz_id: section.quiz_id, language }))
	const questionType = question?.question_type

	const renderHeader = (): JSX.Element => (question?.title ? <SectionHeader title={question?.title} /> : null)

	return (
		<IonGrid
			className={classnames('section-quiz-question', {
				'ion-justify-content-end': questionType === QuestionTypes.FreeText,
			})}
			dir={getDirMode()}
		>
			{renderHeader()}
			<IonRow className="block-content" data-cy="story-screen-section-content">
				<IonCol>
					<IonText className="question-text">{question?.question}</IonText>
					<QuizAnswersContentComponent question={question} quizId={section.quiz_id} />
				</IonCol>
			</IonRow>
		</IonGrid>
	)
}

export default SectionQuizQuestion
